import env from 'configuration'
import { AuthInit } from 'context/auth'
import { LocationInit } from 'context/location'
import useScript from 'hooks/script'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'

function App() {
  const routes = useRoutes(Routes())

  const scriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )

  return (
    <div className='h-screen overflow-y-auto relative'>
      <AuthInit>
        <LocationInit>{routes}</LocationInit>
      </AuthInit>
    </div>
  )
}

export default App
